import { isSocketConnected } from 'components/Socket/ipfSocket';
import { selectLanguage } from 'containers/LanguageProvider/selectors';
import {
  TOASTER_ADD_DANGER,
  TOASTER_ADD_INFO,
  TOASTER_ADD_SUCCESS,
  TOASTER_ADD_WARNING,
} from 'containers/Toaster/constants';
import { translationMessages } from 'i18n';
import get from 'lodash/get';
import { put, select } from 'redux-saga/effects';
import { formatFlash } from './formatFlash';

const messageType = (type) => {
  switch (type) {
    case 'danger':
      return TOASTER_ADD_DANGER;
    case 'success':
      return TOASTER_ADD_SUCCESS;
    case 'info':
      return TOASTER_ADD_INFO;
    case 'warning':
      return TOASTER_ADD_WARNING;
    default:
      return TOASTER_ADD_INFO;
  }
};

export function* requestCustomErrorMessage(type, error) {
  const errCode = get(error, ['code']);
  if (
    errCode === 'API_EXPIRED_ACCESS_TOKEN' ||
    errCode === 'API_INVALID_ACCESS_TOKEN' ||
    errCode === 'API_MAINTENANCE_IN_PROGRESS' ||
    !isSocketConnected()
  ) {
    return; // can be suppressed, we don't want see this errors in frontEnd
  }

  const language = yield select(selectLanguage);
  const messages = translationMessages[language.get('locale')].request;
  const flash = formatFlash(
    get(error, ['payload', 'response', 'response'], error),
    messages,
    type,
  );
  const message = get(flash, 'message', false);
  const title = get(flash, 'title', false);
  if (!title && !message) {
    return;
  }
  yield put({
    type: messageType(get(flash, 'flashType', type || null)),
    payload: {
      message,
      title,
    },
  });
}
